export default "__VITE_ASSET__DAHijgN4__"